/**
 * 品牌字标。
 *
 * 图形部分是一个方块里的 H：两竖一横，并按无人机顶视的四轴姿态在四角各放一个小方块 ——
 * 与平台「机队总览」的四格图标同源，保持品牌与产品视觉一致。
 */
export function Mark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Havorix 标识"
      focusable="false"
    >
      <rect x="1" y="1" width="30" height="30" rx="9" fill="currentColor" opacity="0.1" />
      <rect x="1" y="1" width="30" height="30" rx="9" fill="none" stroke="currentColor" strokeWidth="1.4" opacity="0.4" />
      <g stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" fill="none">
        <path d="M11 9.5v13" />
        <path d="M21 9.5v13" />
        <path d="M11 16h10" />
      </g>
      <g fill="currentColor">
        <rect x="5.2" y="5.2" width="2.6" height="2.6" rx="0.8" opacity="0.65" />
        <rect x="24.2" y="5.2" width="2.6" height="2.6" rx="0.8" opacity="0.65" />
        <rect x="5.2" y="24.2" width="2.6" height="2.6" rx="0.8" opacity="0.65" />
        <rect x="24.2" y="24.2" width="2.6" height="2.6" rx="0.8" opacity="0.65" />
      </g>
    </svg>
  );
}

/** 横排字标：图形 + 字名，字名带 ™。 */
export function Wordmark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <span className={['inline-flex items-center gap-2.5 text-fg', className].filter(Boolean).join(' ')}>
      <Mark size={size} />
      <span className="flex flex-col leading-none">
        <span className="text-[1.0625rem] font-semibold tracking-tight">
          Havorix<span className="align-super text-[0.5rem] font-normal">™</span>
        </span>
        <span className="mt-0.5 text-[0.625rem] tracking-[0.14em] text-fg-muted">低空经济运营监管平台</span>
      </span>
    </span>
  );
}
